import React from 'react'
import styled from 'styled-components'
import { AetnaHierarchyCompanyCard } from '../../../Types/CompaniesTypes'
import { maxWidth, primaryFont, retina, SecondaryColorTwo, wMedium, maxTablet, midTablet } from '../../../Utils/utilsStyle';
import SmartAccountCompanyCard from './SmartAccountCompanyCard';

type Props = {
  companiesData?: AetnaHierarchyCompanyCard[]
  selectedCompanyId: number
  onSelectCompany: (companyId: number) => void
};

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 40px;
  gap: 12px;
  @media all and (max-width:${maxWidth}), ${retina} {
    padding: 20px 40px;
  }
  @media all and (max-width: ${maxTablet}) {
    padding: 20px;
  }
  @media all and (max-width: ${midTablet}) {
    padding: 20px 10px;
  }
  
  .header {
    color: ${SecondaryColorTwo};
    font-family: ${primaryFont};
    font-size: 16px;
    font-style: normal;
    font-weight: ${wMedium};
    line-height: 20px;
    letter-spacing: -0.562px;   
    @media all and (max-width: ${midTablet}) {
      font-size: 13px;
    }
    @media all and (max-width:${maxWidth}), ${retina} {
      font-size: 16px;
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 14px;  
    }
  }  
`

const SmartPlanCompanies = (props: Props) => {
  const { companiesData = [], selectedCompanyId, onSelectCompany } = props;
  const companies = companiesData;

  const headingText = 'Your selection will ensure the Smart Account Plan is correctly mapped and generated under the selected company’s context.';

  return (
    <Wrapper>
      <div className="header">{headingText}</div>
      {
        companies && companies.length > 0 && companies.map((company) => (
          <SmartAccountCompanyCard
            key={company.companyId}
            company={company}
            selected={company.companyId === selectedCompanyId}
            onSelect={() => onSelectCompany(company.companyId)}
          />
        ))
      }
    </Wrapper>
  )
}
export default SmartPlanCompanies